import { FormGroup } from '@angular/forms';
import { ApplianceDetailsSteppedForm } from './appliance-details-stepped-form.interface';

export type ApplianceDetailsSteppedFormValue = ReturnType<
  FormGroup<ApplianceDetailsSteppedForm>['getRawValue']
>;
